import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  DatePicker,
  Col,
  Card,
  Table,
  Form,
  Spin,
  Select,
  Button,
  Statistic,
  Checkbox,
  Divider,
} from "antd";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { rightAction } from "../../../redux/actions";
import CustomButton from "../../../components/custom/CustomButton";

const Search = Input;

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {},
  getCheckboxProps: (record) => ({
    disabled: record.name === "Disabled User",
    name: record.name,
  }),
};

const SearchGLA0900 = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const { RangePicker } = DatePicker;
  const { monthList } = appStatic;
  const { session } = userData;
  const { Text, Title } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [tableCount, setTableCount] = useState("10");
  const [productData, setProductData] = useState([]);
  const [officeData, setOfficeData] = useState([]);
  const [showSummary, setShowSummary] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const [
    includeOutStandingAmountPercentage,
    setIncludeOutStandingAmountPercentage,
  ] = useState(false);
  const [includeOutStandingAmount, setIncludeOutStandingAmount] =
    useState(false);
  const [outStandingAmountCondition, setOutStandingAmountCondition] =
    useState("");
  const [
    outStandingAmountPercentageCondition,
    setOutStandingAmountPercentageCondition,
  ] = useState("");

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCheckedItems({
      ...checkedItems,
      [name]: checked ? name : "",
    });
  };

  const handleIncludeOutStandingAmountPercentage = (e) => {
    console.log(e.target.checked);
    setIncludeOutStandingAmountPercentage(e.target.checked);
  };

  const handleIncludeOutstandingAmount = (e) => {
    console.log(e.target.checked);
    setIncludeOutStandingAmount(e.target.checked);
  };

  function selectTableCount(value) {
    setTableCount(value);
  }

  useEffect(() => {
    getTemplate();
    // //DISABLE ALL RIGHTSIDEBAR ACTION
    dispatch({
      type: cnt.CLEAR_RIGHT_BTN,
    });
    setIsLoading(false);
  }, []);

  function getTemplate() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.FundMappingTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const officeList = res.offices;
        const productList = res.loanProducts;
        let tempOffice = [];
        let tempProduct = [];

        officeList.forEach((element) => {
          tempOffice.push({
            value: element.id,
            label: element.name,
          });
        });
        productList.forEach((element) => {
          tempProduct.push({
            value: element.id,
            label: element.name,
          });
        });

        setOfficeData(tempOffice);
        setProductData(tempProduct);
      }
    });
  }

  const onSubmit = (formValues) => {
    formValues.includeOutStandingAmountPercentage =
      includeOutStandingAmountPercentage;
    formValues.includeOutstandingAmount = includeOutStandingAmount;
    formValues.loanFromDate = BOM.DateTime(formValues.date[0], "only-date");
    formValues.loanToDate = BOM.DateTime(formValues.date[1], "only-date");
    formValues.loanStatus = Object.values(checkedItems).filter(
      (value) => value !== ""
    );
    delete formValues.date;
    delete formValues.all;
    delete formValues.active;
    delete formValues.overpaid;
    delete formValues.closed;
    delete formValues.writeoff;
    delete formValues.dateThree;
    delete formValues.dateTwo;
    delete formValues.glAccountId;
    delete formValues.glAccountIdTwo;
    delete formValues.officeId;
    delete formValues.officeIdTwo;

    // console.log(formValues);
    // return;

    const body = {
      ...formValues,
      locale: "en",
      entities: ["loans"],
      dateFormat: "dd MMMM yyyy",
      method: "POST",
      session,
    };

    setIsLoading(true);
    setShowSummary(true);
    BOM.FetchReqAction(body, definedApi.FundMappingSearch, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        navigate("/gla0900");
      } else {
        const objList = res.pageItems;
        navigate("/gla0900");
        let tempArray = [];

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setJournalEntryList(tempArray.filter((item) => item.disabled === false));
        // setJournalEntryList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        // setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      <TopContent
        pageTitle={appLabel.adHocQuerySearchForLoans}
        pageItems={appStatic.adHocQuerySearchForLoansItem}
      />
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Form
            onFinish={onSubmit}
            layout="vertical"
            style={{ paddingTop: 20, marginBottom: 50 }}
          >
            <Card
              style={{
                marginBottom: "2%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
            >
              {/* RENDER TABLE LIST HERE */}

              {/* LOAN STATUS */}
              <Title level={4}>{appLabel.loanStatus}</Title>
              <Divider style={{ padding: 0, margin: 0 }} />
              <Row style={{ justifyContent: "space-around" }}>
                <Form.Item
                  // name={appStatic.checkBoxItems[0].name}
                  valuePropName="checked"
                >
                  <Checkbox
                    // name={appStatic.checkBoxItems[0].name}
                    // checked={checkedItems[appStatic.checkBoxItems[0].name]}
                    onChange={handleCheckboxChange}
                    style={{
                      width: 400,
                    }}
                  >
                    <Text style={{ fontSize: "16px" }}>{appLabel.all}</Text>
                  </Checkbox>
                </Form.Item>
                <Form.Item
                  // name={appStatic.checkBoxItems[1].name}
                  valuePropName="checked"
                >
                  <Checkbox
                    // name={appStatic.checkBoxItems[1].name}
                    // checked={checkedItems[appStatic.checkBoxItems[1].name]}
                    onChange={handleCheckboxChange}
                    style={{
                      width: 400,
                    }}
                  >
                    <Text style={{ fontSize: "16px" }}>{appLabel.active}</Text>
                  </Checkbox>
                </Form.Item>
                <Form.Item
                  // name={appStatic.checkBoxItems[2].name}
                  valuePropName="checked"
                >
                  <Checkbox
                    // name={appStatic.checkBoxItems[2].name}
                    // checked={checkedItems[appStatic.checkBoxItems[2].name]}
                    onChange={handleCheckboxChange}
                    style={{
                      width: 400,
                    }}
                  >
                    <Text style={{ fontSize: "16px" }}>
                      {appLabel.overPaid}
                    </Text>
                  </Checkbox>
                </Form.Item>
              </Row>
              <Row style={{ justifyContent: "space-around" }}>
                <Form.Item
                  // name={appStatic.checkBoxItems[3].name}
                  valuePropName="checked"
                >
                  <Checkbox
                    // name={appStatic.checkBoxItems[3].name}
                    // checked={checkedItems[appStatic.checkBoxItems[3].name]}
                    onChange={handleCheckboxChange}
                    style={{
                      width: 400,
                    }}
                  >
                    <Text style={{ fontSize: "16px" }}>
                      {appLabel.closedObligationsMet}
                    </Text>
                  </Checkbox>
                </Form.Item>
                <Form.Item
                  // name={appStatic.checkBoxItems[4].name}
                  valuePropName="checked"
                >
                  <Checkbox
                    // name={appStatic.checkBoxItems[4].name}
                    // checked={checkedItems[appStatic.checkBoxItems[4].name]}
                    onChange={handleCheckboxChange}
                    style={{
                      width: 400,
                    }}
                  >
                    <Text style={{ fontSize: "16px" }}>
                      {appLabel.closedWrittenOff}
                    </Text>
                  </Checkbox>
                </Form.Item>
                <div
                  style={{
                    width: 400,
                  }}
                ></div>
              </Row>
              {/* PRODUCT INOFRMATION */}
              <Title level={4}>{appLabel.productInfo}</Title>
              <Divider style={{ padding: 0, margin: 0 }} />
              <Row style={{ justifyContent: "space-around" }}>
                <Form.Item
                  name="loanProducts"
                  label={
                    <Text style={{ fontSize: "16px" }}>{appLabel.loan}</Text>
                  }
                >
                  <Select
                    options={productData}
                    placeholder={BOM.handlePlaceholderMsg(appLabel.loan)}
                    style={{
                      width: 400,
                    }}
                  />
                </Form.Item>
                <Form.Item
                  name="offices"
                  label={
                    <Text style={{ fontSize: "16px" }}>{appLabel.branch}</Text>
                  }
                >
                  <Select
                    onChange={(e) => console.log(e)}
                    options={officeData}
                    placeholder={BOM.handlePlaceholderMsg(appLabel.branch)}
                    style={{
                      width: 400,
                    }}
                  />
                </Form.Item>
                <div
                  style={{
                    width: 400,
                  }}
                ></div>
              </Row>
              <Row style={{ justifyContent: "space-around" }}>
                <Form.Item
                  name="loanDateOption"
                  label={
                    <Text style={{ fontSize: "16px" }}>
                      {appLabel.selectDateType}
                    </Text>
                  }
                >
                  <Select
                    options={appStatic.dateType}
                    placeholder={BOM.handlePlaceholderMsg(
                      appLabel.selectDateType
                    )}
                    style={{
                      width: 400,
                    }}
                  />
                </Form.Item>
                <Form.Item
                  name="date"
                  label={
                    <Text style={{ fontSize: "16px" }}>
                      {appLabel.dateRange}
                    </Text>
                  }
                >
                  <RangePicker
                    style={{
                      width: 400,
                    }}
                  />
                </Form.Item>
                <div
                  style={{
                    width: 400,
                  }}
                ></div>
              </Row>
              {/* LOAN INFORMATION */}
              <Title level={4}>{appLabel.loanInfo}</Title>
              <Divider style={{ padding: 0, margin: 0 }} />
              <Row
                style={{
                  justifyContent: "space-around",
                }}
              >
                <Form.Item name="includeOutStandingAmountPercentage">
                  <Checkbox
                    onChange={handleIncludeOutStandingAmountPercentage}
                    style={{
                      width: 400,
                    }}
                  >
                    <Text style={{ fontSize: "16px" }}>
                      {appLabel.loanOutstandingAmount}
                    </Text>
                  </Checkbox>
                </Form.Item>
                {includeOutStandingAmountPercentage ? (
                  <Form.Item
                    name="outStandingAmountPercentageCondition"
                    label={<Text style={{ fontSize: "16px" }}></Text>}
                  >
                    <Select
                      options={appStatic.relationalItems}
                      onChange={setOutStandingAmountPercentageCondition}
                      placeholder={BOM.handlePlaceholderMsg(appLabel.between)}
                      style={{
                        width: 400,
                      }}
                    />
                  </Form.Item>
                ) : (
                  <div style={{ width: 400 }}></div>
                )}
                {includeOutStandingAmountPercentage ? (
                  <Form.Item
                    name="outStandingAmountPercentage"
                    label={
                      <Text style={{ fontSize: "16px" }}>
                        {outStandingAmountPercentageCondition === ""
                          ? appLabel.between
                          : appStatic.relationalItems.find(
                              (item) =>
                                item.value ===
                                outStandingAmountPercentageCondition
                            ).value}
                      </Text>
                    }
                  >
                    <Input style={{ width: 400 }} />
                  </Form.Item>
                ) : (
                  <div style={{ width: 400 }}></div>
                )}
              </Row>
              <Row style={{ justifyContent: "space-around" }}>
                <Form.Item name="includeOutstandingAmount">
                  <Checkbox
                    style={{
                      width: 400,
                    }}
                    onChange={handleIncludeOutstandingAmount}
                  >
                    <Text style={{ fontSize: "16px" }}>
                      {appLabel.loanOutstandingPercentage}
                    </Text>
                  </Checkbox>
                </Form.Item>
                {includeOutStandingAmount ? (
                  <Form.Item
                    name="outstandingAmountCondition"
                    label={<Text style={{ fontSize: "16px" }}></Text>}
                  >
                    <Select
                      options={appStatic.relationalItems}
                      onChange={setOutStandingAmountCondition}
                      placeholder={BOM.handlePlaceholderMsg(appLabel.between)}
                      style={{
                        width: 400,
                      }}
                    />
                  </Form.Item>
                ) : (
                  <div style={{ width: 400 }}></div>
                )}
                {includeOutStandingAmount ? (
                  <Form.Item
                    name="outstandingAmount"
                    label={
                      <Text style={{ fontSize: "16px" }}>
                        {outStandingAmountCondition === ""
                          ? appLabel.between
                          : appStatic.relationalItems.find(
                              (item) =>
                                item.value === outStandingAmountCondition
                            ).value}
                      </Text>
                    }
                  >
                    <Input style={{ width: 400 }} />
                  </Form.Item>
                ) : (
                  <div style={{ width: 400 }}></div>
                )}
              </Row>
            </Card>
            <Form.Item>
              <Row>
                <CustomButton
                  content="Summary"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              </Row>
            </Form.Item>
          </Form>
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(SearchGLA0900);
